module.exports = __webpack_public_path__ + "static/media/nasa-min.4e5b07a2.png";